const Mutations = {
    SET_USER: (state, user) => {
        state.user = user
    }, 
    SET_TOKEN: (state, token) => {
        state.token = token
    }, 
    GET_PROPERTY_OWNERS: (state, owners) => {
        state.property_owners = owners
    }, 
    GET_PROPERTY_MANAGERS: (state, managers) => {
        state.property_managers = managers
    }, 
    GET_ALL_PROPERTY_RESIDENTS: (state, residents) => {
        state.residents = residents
    }, 
    GET_TOTAL_USERS: (state, count) => {
        state.user_count = count
    }, 
    GET_TOTAL_MANAGERS: (state, count) => {
        state.managers_count = count
    }, 
    SET_AUTHENTICATED: (state, val) => {
        let value;
        if(val === true) {
            value = true
        }else{
            value = false
        }
        state.authenticated = value
    }
};

export default Mutations;